var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMesterhus = function SvgMesterhus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7705 89.1017L90.4932 111.238H90.9736L97.5361 89.1017H131.311L102.658 177.943H77.5811L48.6611 89.1017H83.7705ZM180 177.943H139.315V89.1017H180V177.943ZM40.6846 177.942H0V89.1007H40.6846V177.942Z",
    fill: "#152338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3584 2L83.7695 89.1055H48.6611L41.1914 66.168H40.6846V89.1055H0V2H57.3584ZM179.972 2V89.1055H139.287V65.9277H138.808L131.311 89.1055H97.5361L123.36 2H179.972Z",
    fill: "#F92B1C"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMesterhus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mesterhus.22eb2cb49fd9f3b99e2a2a99a429afc3.svg";